module.exports = __webpack_public_path__ + "static/media/microsoft-office.5c7e4c7b.png";